/* eslint-disable import/prefer-default-export */
export const createCriteriaFormValuesSelector = (state) =>
  state.forms.criteria.create
